import { render } from "./RequestService.vue?vue&type=template&id=4d8a031d&scoped=true"
import script from "./RequestService.vue?vue&type=script&lang=js"
export * from "./RequestService.vue?vue&type=script&lang=js"

import "./RequestService.vue?vue&type=style&index=0&id=4d8a031d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8a031d"]])

export default __exports__